import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../Context/LanguageContext';
import { normalizeCenterType } from '../../Utils/centerTypeUtils';

import { ReactComponent as ChevronIcon } from '../../image/DownArrow.svg';
import { ReactComponent as CheckIcon } from '../../image/Check.svg';

export default function CenterTypeSelect(props) {
  const { label, defaultVal, setVal } = props;

  const { t } = useLanguage();

  const options = [
    { value: 'crossfit', text: t('myStoreSetting.centerType.crossfit') },
    { value: 'hyrox', text: t('myStoreSetting.centerType.hyrox') },
    { value: 'crossTraining', text: t('myStoreSetting.centerType.crossTraining') },
    { value: 'pilates', text: t('myStoreSetting.centerType.pilates') },
    { value: 'pt', text: t('myStoreSetting.centerType.pt') },
    { value: 'groupPt', text: t('myStoreSetting.centerType.groupPt') },
    { value: 'bodyCorrection', text: t('myStoreSetting.centerType.bodyCorrection') },
    { value: 'weightTraining', text: t('myStoreSetting.centerType.weightTraining') },
    { value: 'bodybuilding', text: t('myStoreSetting.centerType.bodybuilding') },
    { value: 'dietProgram', text: t('myStoreSetting.centerType.dietProgram') },
    { value: 'bodyProfile', text: t('myStoreSetting.centerType.bodyProfile') },
    { value: 'womensFitness', text: t('myStoreSetting.centerType.womensFitness') },
    { value: 'seniorFitness', text: t('myStoreSetting.centerType.seniorFitness') },
    { value: 'kidsFitness', text: t('myStoreSetting.centerType.kidsFitness') },
    { value: 'gxProgram', text: t('myStoreSetting.centerType.gxProgram') },
    { value: 'functionalTraining', text: t('myStoreSetting.centerType.functionalTraining') },
    { value: 'personalTraining', text: t('myStoreSetting.centerType.personalTraining') },
    { value: 'rehabTraining', text: t('myStoreSetting.centerType.rehabTraining') },
    { value: 'sportsPerformance', text: t('myStoreSetting.centerType.sportsPerformance') },
    { value: 'powerlifting', text: t('myStoreSetting.centerType.powerlifting') },
    { value: 'flyingYoga', text: t('myStoreSetting.centerType.flyingYoga') },
    { value: 'vinyasaYoga', text: t('myStoreSetting.centerType.vinyasaYoga') },
    { value: 'cyclingClass', text: t('myStoreSetting.centerType.cyclingClass') },
    { value: 'muaythaiFitness', text: t('myStoreSetting.centerType.muaythaiFitness') },
    { value: 'mmaFitness', text: t('myStoreSetting.centerType.mmaFitness') },
    { value: 'jiujitsuConditioning', text: t('myStoreSetting.centerType.jiujitsuConditioning') },
    { value: 'runningClass', text: t('myStoreSetting.centerType.runningClass') },
    { value: 'marathonTraining', text: t('myStoreSetting.centerType.marathonTraining') },
    { value: 'hiitTraining', text: t('myStoreSetting.centerType.hiitTraining') },
    { value: 'circuitTraining', text: t('myStoreSetting.centerType.circuitTraining') },
    { value: 'coreTraining', text: t('myStoreSetting.centerType.coreTraining') },
    { value: 'kettlebellTraining', text: t('myStoreSetting.centerType.kettlebellTraining') },
    { value: 'stretchingClass', text: t('myStoreSetting.centerType.stretchingClass') },
    { value: 'mobilityClass', text: t('myStoreSetting.centerType.mobilityClass') },
    { value: 'calisthenics', text: t('myStoreSetting.centerType.calisthenics') },
    { value: 'strongmanTraining', text: t('myStoreSetting.centerType.strongmanTraining') },
    { value: 'emsTraining', text: t('myStoreSetting.centerType.emsTraining') },
    { value: 'others', text: t('myStoreSetting.centerType.others') },
  ];

  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(normalizeCenterType(defaultVal) || options[0].value);

  const wrapperRef = useRef(null);

  // 외부 클릭 시 셀렉트 닫기 //
  useEffect(() => {
    function onClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', onClickOutside);

    return () => document.removeEventListener('mousedown', onClickOutside);
  }, [])

  function onClickToggle() {
    setIsOpen(prev => !prev);
  }

  function onClickOption(option) {
    setSelectedValue(option.value);
    setVal(option.value);
    setIsOpen(false);
  }

  return (
    <TopLevelWrapper ref={wrapperRef}>
      {
        label &&
        <Label>{label}</Label>
      }
      <SelectBox onClick={onClickToggle}>
        <SelectedText>{options.find(o => o.value === selectedValue)?.text || ''}</SelectedText>
        <ChevronWrapper isOpen={isOpen}>
          <ChevronIcon />
        </ChevronWrapper>
      </SelectBox>
      {
        isOpen &&
        <OptionList>
          {
            options.map((option) => (
              <OptionItem
                key={'CenterType-' + option.value}
                $isSelected={option.value === selectedValue}
                onClick={() => onClickOption(option)}>
                <OptionText $isSelected={option.value === selectedValue}>{option.text}</OptionText>
                {
                  option.value === selectedValue &&
                  <OptionCheckIcon>
                    <CheckIcon />
                  </OptionCheckIcon>
                }
              </OptionItem>
            ))
          }
        </OptionList>
      }
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  gap: 5px;

  width: 100%;
`;

const Label = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;

const SelectBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 32px;

  padding: 5px 10px;
  box-sizing: border-box;

  border: 1px dashed ${props => props.theme.line};
  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const SelectedText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const ChevronWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 14px;
  height: 8px;

  transform: rotate(${props => props.isOpen ? '180deg' : '0deg'});
  transition: transform 0.2s ease-in-out;

  color: ${props => props.theme.text};

  & svg {
    width: 100%;
    height: 100%;
  }
`;

const OptionList = styled.div`
  position: absolute;

  display: flex;
  flex-direction: column;

  top: 100%;
  left: 0;
  right: 0;

  margin-top: 4px;

  max-height: 240px;
  overflow-y: auto;
  z-index: 10;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};

  &::-webkit-scrollbar {
    width: 9px;
  }

  &::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px ${props => props.theme.primary};
    border: 3px solid transparent;
    border-radius: 200px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

const OptionItem = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  box-sizing: border-box;

  padding: 6px 10px;

  background-color: transparent;

  transition: background-color 0.15s ease-in-out;

  -webkit-tap-highlight-color: transparent;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.primary};
    }

    &:hover p {
      color: ${props => props.theme.white};
    }

    &:hover svg {
      color: ${props => props.theme.white};
    }
  }

  &:active {
    background-color: ${props => props.theme.primary};
  }

  &:active p {
    color: ${props => props.theme.white};
  }

  &:active svg {
    color: ${props => props.theme.white};
  }
`;

const OptionText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.$isSelected ? props.theme.primary : props.theme.text};

  margin: 0 0 0 0;

  transition: color 0.15s ease-in-out;
`;

const OptionCheckIcon = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  flex-shrink: 0;

  color: ${props => props.theme.primary};

  & svg {
    width: 12px;
    height: 9px;
  }
`;
